module.exports = __webpack_public_path__ + "static/dagny-regular-5ba42f843fb97a8be18688803d06d92a.woff";